export enum SubmissionDetailsFieldChangeTypeEnum {
  Previous,
  New
}
